export interface AuditMetrics {
  monthEvents: number;
  activeUsers: number;
  criticalAlerts: number;
  complianceRate: number;
}

export interface RecentEvent {
  id: string;
  title: string;
  user: string;
  amount?: string;
  timestamp: string;
  author: string;
  severity: 'Normal' | 'Media' | 'Alta';
}

export interface SecurityStatus {
  status: string;
  authenticatedUsers: number;
  activeSessions: number;
}

export interface RecentAccessAttempt {
  id: string;
  user: string;
  status: 'Exitoso' | 'Fallido';
  timestamp: string;
}

export interface LogRetention {
  description: string;
  days: number;
}

export interface NotificationSetting {
  description: string;
  enabled: boolean;
}

export interface ExportOption {
  title: string;
  description: string;
}

export const auditMetrics: AuditMetrics = {
  monthEvents: 1247,
  activeUsers: 23,
  criticalAlerts: 3,
  complianceRate: 98.2,
};

export const recentEvents: RecentEvent[] = [
  {
    id: '1',
    title: 'Aprobó adelanto de nómina',
    user: 'Ana García Mendoza - $8,500',
    timestamp: '2024-01-18 14:30',
    author: 'Miguel Admin',
    severity: 'Normal',
  },
  {
    id: '2',
    title: 'Configuración modificada',
    user: 'Límites de adelanto actualizados',
    timestamp: '2024-01-18 13:15',
    author: 'Sistema',
    severity: 'Media',
  },
  {
    id: '3',
    title: 'Empleado agregado',
    user: 'Roberto Vásquez - Onboarding iniciado',
    timestamp: '2024-01-18 11:45',
    author: 'Laura HR',
    severity: 'Normal',
  },
  {
    id: '4',
    title: 'Intento de acceso fallido',
    user: 'IP: 192.168.1.100 - 3 intentos',
    timestamp: '2024-01-18 09:20',
    author: 'Sistema',
    severity: 'Alta',
  },
];

export const securityStatus: SecurityStatus = {
  status: 'Todos los sistemas funcionando correctamente',
  authenticatedUsers: 12,
  activeSessions: 8,
};

export const recentAccessAttempts: RecentAccessAttempt[] = [
  {
    id: '1',
    user: 'Miguel Admin',
    status: 'Exitoso',
    timestamp: '14:30',
  },
  {
    id: '2',
    user: 'Laura HR',
    status: 'Exitoso',
    timestamp: '13:15',
  },
  {
    id: '3',
    user: 'Desconocido',
    status: 'Fallido',
    timestamp: '09:20',
  },
];

export const logRetention: LogRetention = {
  description: 'Los registros se mantienen por 365 días',
  days: 365,
};

export const notificationSettings: NotificationSetting[] = [
  {
    description: 'Alertas automáticas habilitadas',
    enabled: true,
  },
];

export const exportOptions: ExportOption[] = [
  {
    title: 'Retención de Logs',
    description: 'Los registros se mantienen por 365 días',
  },
  {
    title: 'Notificaciones',
    description: 'Alertas automáticas habilitadas',
  },
  {
    title: 'Exportación',
    description: 'Exportar registros de auditoría',
  },
];

